import debounce from '@mui/utils/debounce';
export default debounce;
